import { useMemo } from 'react';

export const useAreDatesValid = (date_from, date_to) => useMemo(() => {
  if (!date_from || !date_to) return false;
  const from = new Date(date_from);
  const to = new Date(date_to);
  return from <= to;
}, [date_from, date_to]);
